var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.disabledMode')
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.optionModel.disabledMode),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "disabledMode", $$v)
      },
      expression: "optionModel.disabledMode"
    }
  })], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e60638a","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/setting-panel/property-editor/container-vf-dialog/disabledMode-editor.vue
// module id = null
// module chunks = 